import { Card, CardContent } from '@/components/ui/card';

export function CardSkeleton() {
  return (
    <Card className="overflow-hidden border-black">
      <div className="flex flex-col md:flex-row">
        <div className="h-48 animate-pulse bg-neutral-200 md:h-full md:w-64 lg:w-80" />
        <CardContent className="flex-1 p-4">
          <div className="mb-3 flex items-start justify-between">
            <div className="h-6 w-12 animate-pulse rounded bg-neutral-200" />
            <div className="h-6 w-16 animate-pulse rounded bg-neutral-200" />
          </div>
          <div className="mb-2 h-7 w-full animate-pulse rounded bg-neutral-200" />
          <div className="mb-2 h-7 w-4/5 animate-pulse rounded bg-neutral-200" />
          <div className="mb-2 h-4 w-full animate-pulse rounded bg-neutral-200" />
          <div className="mb-3 h-4 w-4/5 animate-pulse rounded bg-neutral-200" />
          <div className="flex items-center justify-between">
            <div className="h-4 w-24 animate-pulse rounded bg-neutral-200" />
            <div className="h-4 w-20 animate-pulse rounded bg-neutral-200" />
          </div>
        </CardContent>
      </div>
    </Card>
  );
}

export function NewsGridSkeleton() {
  return (
    <div className="mx-auto flex w-full max-w-5xl flex-col gap-4">
      {Array.from({ length: 3 }).map((_, i) => (
        <CardSkeleton key={i} />
      ))}
    </div>
  );
}
